import { Component, Injectable } from '@angular/core';
import { NavController, NavParams, ViewController, App } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the StockListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-popup-info',
  templateUrl: 'popup-info.html',
})
@Injectable({
  providedIn: 'root'
})

export class PopupInfoPage {
  title: any;
  origin: any;
  type: any;
  msg: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public globals: Globals,
    public app: App,
    public translate: TranslateService) {
    this.origin = this.navParams.get('origin');
    this.type = this.navParams.get('type');
  }

  close() {
    this.viewCtrl.dismiss();
  }


}


// WEBPACK FOOTER //
// ./src/pages/components/popups/popup-info/popup-info.ts